import { useEffect, useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Wordmark } from './Wordmark';
import { Typography } from './Typography';
import { Button } from './Button';
import { navigation } from '../content/site';
import styles from './Header.module.css';
export function Header({ inverse = false }: { inverse?: boolean }) {
  const [open, setOpen] = useState(false);
  useEffect(() => {
    if (!open) return;
    const handle = (e: KeyboardEvent) => {
      if (e.key === 'Escape') setOpen(false);
    };
    window.addEventListener('keydown', handle);
    return () => window.removeEventListener('keydown', handle);
  }, [open]);
  return (
    <header className={`${styles.header} ${inverse ? styles.inverse : ''}`}>
      <div className={styles.inner}>
        <Wordmark inverse={inverse} />
        <span className={styles.divider} aria-hidden />
        <nav className={styles.desktop} aria-label="Основная навигация">
          {navigation.map((n) => (
            <a className={styles.navLink} key={n.href} href={n.href}>
              <Typography as="span" tone="inherit">
                {n.label}
              </Typography>
            </a>
          ))}
        </nav>
        <div className={styles.cta}>
          <Button href="/contact/" variant={inverse ? 'secondary' : 'ghost'}>
            Запросить КП
          </Button>
        </div>
        <button
          className={styles.toggle}
          aria-label={open ? 'Закрыть меню' : 'Открыть меню'}
          aria-expanded={open}
          aria-controls="mobile-navigation"
          onClick={() => setOpen(!open)}
        >
          {open ? <X aria-hidden /> : <Menu aria-hidden />}
        </button>
      </div>
      {open && (
        <nav className={styles.mobile} id="mobile-navigation" aria-label="Мобильная навигация">
          {navigation.map((n) => (
            <a className={styles.navLink} key={n.href} href={n.href} onClick={() => setOpen(false)}>
              <Typography as="span" variant="subheading" tone="inherit">
                {n.label}
              </Typography>
            </a>
          ))}
          <Button href="/contact/" variant="primary">
            Запросить КП
          </Button>
        </nav>
      )}
    </header>
  );
}
